import { render, staticRenderFns } from "./AppSnackBar.vue?vue&type=template&id=21f9e2dd"
import script from "./AppSnackBar.vue?vue&type=script&lang=js"
export * from "./AppSnackBar.vue?vue&type=script&lang=js"
import style0 from "./AppSnackBar.vue?vue&type=style&index=0&id=21f9e2dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports